<template>
  <div class="pro-report">
    <div class="u-time">
      <div class="f-dfa">
        <div>
          <van-icon name="arrow-left"
                    @click="lf()" />
        </div>
        <div class="date"
             @click="show = true;">{{reportDate}}</div>
        <div>
          <van-icon name="arrow"
                    @click="rg()" />
        </div>
      </div>
      <div class="f-dfa"
           @click="initReportList">
        <div class="bb">
          <van-icon name="todo-list-o"
                    size="16px" />
        </div>
        报表
      </div>
    </div>
    <van-popup v-model="show"
               position="bottom">
      <!-- <van-datetime-picker show-toolbar
                           title="选择时间"
                           v-model="currentDate"
                           type="year-month"
                           :min-date="minDate"
                           :max-date="maxDate"
                           @confirm="onConfirm"
                           @cancel="onCancel" /> -->
      <van-datetime-picker v-model="currentDate"
                           type="date"
                           title="选择时间"
                           :min-date="minDate"
                           :max-date="maxDate"
                           @confirm="onConfirm"
                           @cancel="onCancel" />
    </van-popup>
    <van-popup v-model="show2"
               position="bottom"
               class="popup-list">
      <div class="itembox"
           v-for="(item,index) in list"
           :key="index">
        <div class="item"
             v-for="(item2,index2) in item.list"
             :key="index2"
             @click='jumpUrl(item2.REPORT_URL)'>{{item2.NAME}}</div>
      </div>

    </van-popup>

    <van-tabs v-model="active"
              @click="getHrReportDetail">
      <van-tab v-for="(item,index) in organizationList"
               :key="index"
               :title=item></van-tab>
    </van-tabs>
    <div class="overview">
      <div class="tt">
        {{detail.company}}&emsp;流程概况
      </div>
      <ul class="detail"
          v-if="detail.companyDetail !== undefined && detail.companyDetail.length == 0">
        <div class="noinfo">暂无数据</div>
      </ul>
      <ul class="detail"
          v-else>
        <li>
          <div class="num">{{detail.companyDetail.AMOUT}}</div>
          <div class="name">本月发起</div>
          <i class="line"></i>
        </li>
        <li>
          <div class="num">{{detail.companyDetail.FINAMOUT}}</div>
          <div class="name">已办结</div>
          <i class="line"></i>
        </li>
        <li>
          <div class="num">{{detail.companyDetail.AVGFINTIME}}</div>
          <div class="name">办结率</div>
          <i class="line"></i>
        </li>
        <li>
          <div class="num">{{detail.companyDetail.UNFINAMOUT}}</div>
          <div class="name">本年累计未办结</div>
        </li>
      </ul>

    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <template #title>
          <div class="tt">
            <span>办件效率(按部门)</span>
          </div>
        </template>
        <div>

          <ul class="eff-report"
              :class="{'animation':flag}">
            <li class="head">
              <div class="name">部门</div>
              <div class="num"
                   @click="ranking">办件总数
                <i class="sort"></i>
              </div>
              <div class="time"
                   @click="ranking2">审批平均耗时(h)
                <i class="sort"></i>
              </div>
              <div class="ranking">排名</div>
            </li>
            <li v-if="countRank"
                v-for="item in countDepList"
                :key="item.id">
              <div class="name">{{item.DEPART}}</div>
              <div class="num">{{item.COUNT}}</div>
              <div class="time">{{item.avgAppTime}}</div>
              <div class="ranking">
                <span>{{item.countRank}} </span>
              </div>
            </li>
            <li v-if="!countRank"
                v-for="item in avgDepList"
                :key="item.id">
              <div class="name">{{item.DEPART}}</div>
              <div class="num">{{item.COUNT}}</div>
              <div class="time">{{item.avgAppTime}}</div>
              <div class="ranking">
                <span>{{item.avgRank}} </span>
              </div>
            </li>
          </ul>
          <div class="ellipsis"
               @click="flag = !flag">
            <van-icon name="ellipsis"
                      v-if="!flag"
                      color="#1989fa"
                      size="8vw" />
            <van-icon name="ascending"
                      v-else
                      color="#1989fa"
                      size="8vw" />
          </div>
        </div>
      </van-collapse-item>

      <van-collapse-item name="2">
        <template #title>
          <div class="tt">
            <span>办件效率(按10名人员)</span>

          </div>
        </template>
        <div>
          <ul class="eff-report">
            <li class="head">
              <div class="name">姓名</div>
              <div class="num"
                   @click="rankingP">办件总数
                <i class="sort"></i>
              </div>
              <div class="time"
                   @click="rankingP2">审批平均耗时(h)
                <i class="sort"></i>
              </div>
              <div class="ranking">排名</div>
            </li>
            <li class="myself"
                v-if="detail.perMap && detail.perMap.myself">
              <div class="name">{{detail.perMap.myself.FD_NAME}}</div>
              <div class="num">{{detail.perMap.myself.COUNT}}</div>
              <div class="time">{{detail.perMap.myself.AVGAPPTIME}}</div>
              <div v-if="countRank2"
                   class="ranking">{{detail.perMap.myself.countRank}}</div>
              <div v-if="!countRank2"
                   class="ranking">{{detail.perMap.myself.avgRank}}</div>
            </li>
            <li v-if="countRank2"
                v-for="item in countDepList2.slice(0, 10)"
                :key="item.id">

              <div class="name">{{item.FD_NAME}}</div>
              <div class="num">{{item.COUNT}}</div>
              <div class="time">{{item.AVGAPPTIME}}</div>
              <div class="ranking">{{item.countRank}}</div>
            </li>
            <li class="noinfo"
                v-if="countDepList2 !== undefined && countDepList2.length == 0">暂无数据</li>
            <li v-if="!countRank2"
                v-for="item in avgDepList2.slice(0, 10)"
                :key="item.id">
              <div class="name">{{item.FD_NAME}}</div>
              <div class="num">{{item.COUNT}}</div>
              <div class="time">{{item.AVGAPPTIME}}</div>
              <div class="ranking">{{item.avgRank}}</div>
            </li>
          </ul>
        </div>
      </van-collapse-item>
      <van-collapse-item name="3">
        <template #title>
          <div class="tt">
            <span>流程效率</span>
          </div>
        </template>
        <div>
          <ul class="eff-report eff-report2">
            <li class="head">
              <div class="name">流程类别</div>
              <div class="time">办结平均耗时(h) </div>
              <div class="ranking">排名</div>
              <div class="num">本年累计未办结(h)</div>
            </li>

            <li v-for="item in detail.procedureList"
                :key="item.id">
              <div class="name">{{item.TEMP}}</div>
              <div class="time">{{item.AVGAPPTIME}}</div>
              <div class="ranking">{{item.avgRank}}</div>
              <div class="num">{{item.unFinAppAvg}}</div>
            </li>
            <li class="noinfo"
                v-if="detail.procedureList !== undefined && detail.procedureList.length == 0 ">暂无数据</li>
          </ul>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import api from "@/axios/api";
import { Toast } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.getMatch(this.reportDate);
        }
      }
    }
  },
  data () {
    return {
      active: 0,
      organizationList: [],
      detail: {},
      userId: "",
      activeNames: ["1"],
      countRank: true,
      countRank2: true,
      countDepList: [],
      avgDepList: [],
      countDepList2: [],
      avgDepList2: [],
      flag: false,
      title: "澳洋集团有限公司",

      reportDate: this.$route.query.reportDate,
      show: false,
      show2: false,
      list: [],
      minDate: new Date(2021, 0, 1),
      maxDate: new Date(new Date() - 86400000),
      currentDate: new Date(new Date() - 86400000),
    };
  },

  filters: {},
  mounted () {
    //this.getMatch(this.reportDate);
  },
  methods: {
    initReportList () {
      this.show2 = true;
      api.getListDataItems().then(res => {
        this.list = res
      })
    },
    jumpUrl (url) {
      if (url) {
        //var newUrl = url+"?date="+this.reportDate;
        var newUrl = url.replace('yyyyMMdd', this.reportDate);
        this.show2 = false;
        window.location.href = newUrl;
      } else {
        alert("报表路径有误，无法查看");
      }
    },
    getMatch (time) {
      let par = {
        date: time
      };
      api.getMatch(par).then(res => {
        let mon = new Date().getMonth();
        if (mon < 0) {
          this.maxDate = new Date(new Date().getFullYear() - 1, 11);
        } else {
          this.maxDate = new Date(new Date().getFullYear(), mon);
        }
        this.organizationList = res.organizationList;
        this.detail = res.detail;
        this.userId = res.userId;
        this.countDepList = this.detail.depList;
        this.countDepList2 = this.detail.perMap.list;
        let sort = this.countDepList.slice(0);
        if (this.countDepList2) {
          let sort2 = this.countDepList2.slice(0);

          this.avgDepList2 = sort2.sort(function (a, b) {
            return b.avgRank - a.avgRank;
          });
        } else {
          this.countDepList2 = [];
        }

        this.avgDepList = sort.sort(function (a, b) {
          return b.avgRank - a.avgRank;
        });
        if (this.detail.procedureList) {
          this.detail.procedureList.sort(function (a, b) {
            return a.avgRank - b.avgRank;
          });
        }
      });
    },
    ranking (isTrue, arr) {
      this.countRank = true;
      this.countDepList.reverse();
    },
    ranking2 (isTrue, arr) {
      this.countRank = false;
      this.avgDepList.reverse();
    },
    rankingP (isTrue, arr) {
      this.countRank2 = true;
      if (this.countDepList2) {
        this.countDepList2.reverse();
      }
    },
    rankingP2 (isTrue, arr) {
      this.countRank2 = false;
      this.avgDepList2.reverse();
    },
    getHrReportDetail (name, title) {
      this.title = title;
      let params = {
        company: title,
        userId: this.userId,
        useDate: this.reportDate
      };
      api.getHrReportDetail(params).then(res => {
        this.detail = res;
        this.countDepList = this.detail.depList;
        this.countDepList2 = this.detail.perMap.list;
        let sort = this.countDepList.slice(0);
        if (this.countDepList2) {
          let sort2 = this.countDepList2.slice(0);
          this.avgDepList2 = sort2.sort(function (a, b) {
            return b.avgRank - a.avgRank;
          });
        } else {
          this.countDepList2 = [];
        }

        this.avgDepList = sort.sort(function (a, b) {
          return b.avgRank - a.avgRank;
        });

        if (this.detail.procedureList) {
          this.detail.procedureList.sort(function (a, b) {
            return a.avgRank - b.avgRank;
          });
        }
      });
    },
    onConfirm (picker, value, index) {
      this.show = false;
      let year = this.currentDate.getFullYear();
      let month = this.currentDate.getMonth() + 1;
      let date = this.currentDate.getDate();
      this.reportDate = year + "-" + this.add(month) + "-" + this.add(date);
      //更新报表
      this.getHrReportDetail("", this.title);
    },
    onCancel () {
      this.show = false;
    },
    add (num) {
      if (num < 10) return "0" + "" + num;
      else return num;
    },
    lf () {
      let date = this.reportDate;
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2];
      var year2 = year;
      var month2 = parseInt(month);
      var day2 = parseInt(day) - 1;

      if (day2 == 0) {
        month2 = parseInt(month2) - 1;
        if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
          day2 = 31;
        }
        if (month2 == 1 || month2 == 3 || month2 == 5 || month2 == 7 || month2 == 8 || month2 == 10 || month2 == 12) {
          day2 = 31;
        } else {
          day2 = 30;
        }
      }
      var mdate = new Date(year2, this.add(month2) - 1, this.add(day2)) - this.minDate;
      if (mdate > 0) {
        this.reportDate = year2 + '-' + this.add(month2) + '-' + this.add(day2);
        //更新报表
        this.getHrReportDetail("", this.title);
      } else {
        Toast.fail("无法选择更早的时间");
      }
    },
    rg () {
      let date = this.reportDate;
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2];
      var year2 = year;
      var month2 = parseInt(month);
      var day2 = parseInt(day) + 1;
      if (month2 == 1 || month2 == 3 || month2 == 5 || month2 == 7 || month2 == 8 || month2 == 10 || month2 == 12) {
        if (day2 > 31) {
          month2 = month2 + 1;
          day2 = 1
        }
      } else {
        if (day2 > 30) {
          month2 = month2 + 1;
          day2 = 1
        }
      }

      if (month2 == 13) {
        year2 = parseInt(year2) + 1;
        month2 = 1;
      }


      var mdate = new Date(year2, this.add(month2) - 1, this.add(day2)) - this.maxDate;


      if (mdate <= 0) {
        this.reportDate = year2 + '-' + this.add(month2) + '-' + this.add(day2);
        //更新报表
        this.getHrReportDetail("", this.title);
      } else {
        Toast.fail("无法选择更晚的时间");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pro-report {
  .f-dfa {
    display: flex;
    align-items: center;
  }
  .u-time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4vw;
    background: #5584ff;
    color: #fff;
  }
  .date {
    display: flex;
    align-items: center;
    margin: 0 2vw;
  }
  .bb {
    margin-right: 1vw;
  }
  .popup-list {
    padding: 4vw;
    height: 94vw;
    overflow-y: scroll;
    border-radius: 12px 12px 0 0;
    box-sizing: border-box;
  }
  .popup-list .itembox {
    padding: 2vw 0;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
  }
  .popup-list .itembox:last-child {
    border-bottom: none;
  }
  .popup-list .itemname {
    padding: 4vw 2vw 2vw 2vw;
    font-size: 18px;
    font-weight: 700;
    text-align: left;
  }
  .popup-list .item {
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 8vw;
    margin: 2vw;
    padding: 2vw 4vw;
    font-size: 16px;
    background: #f1f1f1;
    color: #5f7091;
    border-radius: 60px;
  }
  /deep/.van-tab--active {
    color: #477aff;
    font-weight: 700;
  }
  /deep/.van-tabs__line {
    background-color: #477aff;
  }
  .overview {
    .noinfo {
      width: 100%;
      text-align: center;
      color: #fff;
    }
    .tt {
      margin-top: 2.6vw;
      padding: 3.6vw 3.2vw;
      text-align: left;
      font-size: 14px;
      font-weight: bold;
      color: #282828;
      background: #fff;
    }
    .detail {
      display: flex;
      padding: 7vw 0 5.3vw 0;
      background: #477aff;
      li {
        position: relative;
        flex: 1;
        .num {
          font-size: 16px;
          font-weight: 700;
          color: #fff;
        }
        .name {
          margin-top: 2vw;
          font-size: 12px;
          color: #d1deff;
        }
        .line {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 1px;
          height: 8.6vw;
          background: #95b3ff;
        }
      }
    }
  }
  /deep/.van-collapse {
    /deep/.van-collapse-item__content {
      padding: 0;
    }
    .tt {
      display: flex;
      justify-content: space-between;
      font-weight: 700;
      .sort {
        display: flex;
        align-items: center;
        margin-right: 2vw;
        padding: 0 2vw;
        background: #dceaff;
        border-radius: 4px;
        font-size: 12px;
        color: #6a6a6a;
      }
    }
    .eff-report {
      max-height: calc(88vw + 165px);
      overflow: hidden;
      transition: all 1.5s ease;
      .noinfo {
        justify-content: center;
      }
      div {
        line-height: 1;
      }
      .myself {
        font-weight: 700;
        .ranking {
          color: #3c3c3c;
        }
      }
      li {
        display: flex;
        padding: 4vw;
        color: #3c3c3c;
        border-bottom: 1px solid #e3e3e3;
        .name {
          width: 29%;
          text-align: left;
        }
        .num {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24%;
        }
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 34%;
        }
        .ranking {
          width: 13%;
          color: #db2828;
        }
      }
      .head {
        background: #e2eafe;
        color: #477aff;
        .ranking {
          color: #477aff;
        }
        i {
          display: inline-block;
          width: 2.8vw;
          height: 3.2vw;
          margin-left: 1vw;
          background: url(../assets/rlzy/sort.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .animation {
      max-height: initial;
    }
    .ellipsis {
      padding: 2vw 0;
      line-height: 1;
    }

    .eff-report2 {
      max-height: inherit;
      .head {
        div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .name {
          justify-content: flex-start;
        }
      }
      li {
        .name {
          width: 30%;
          text-align: left;
        }
        .num {
          width: 20%;
        }
        .time {
          width: 30%;
        }
        .ranking {
          width: 20%;
          color: #db2828;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/rlzy/proReport.vue